<div class="-docheader-sec-nav -container">
  <ul class="is-loading">
    @for (tab of skeletonTabs; track tab) {
    <li class="-skeleton">
      <wp-skeleton class="-skeleton-bar" [loading]="true"></wp-skeleton>
    </li>
    }
  </ul>
</div>
